export default async function () {
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'branch'
  ) {
    window.location.href = 'https://testso.n11.com/selleroffice/login';
  } else {
    window.location.href = '/selleroffice/login';
  }
}
